/**
 * COMPARTMENT_ITEM_ID — identifiers for all possible data fields in a compartment detail view.
 *
 * Each ID maps to one entry in COMPARTMENT_ITEM_REGISTRY (see utils/popoverItems.js).
 * Both the InfoMode popover and the CompartmentsList expandedRow consume the same registry
 * via buildCompartmentItems(), gated by the same `settings` shape.
 *
 * Adding a new displayable field: add a constant here + a registry entry there.
 * Availability is controlled through:
 *   - panelSettings.unit_sheet_mode_info.compartment_popover  (popover)
 *   - panelSettings.unit_sheet_compartments.tile_expansion_fields  (expandedRow)
 */
export const COMPARTMENT_ITEM_ID = {
  AREA:             'area',
  EXPOSITION:       'exposition',
  INSOLATION_RANGE: 'insolation_range',
  INSOLATION_HOURS: 'insolation_hours',
  WINDOWS_RATIO:    'windows_ratio',
  WINDOWS_AREA:     'windows_area',
  ZONE:             'zone',
  // HEIGHT:        'height',            // net height of the compartment
  // WIDTH:         'width',             // compartment width (shorter side)
  // DEPTH:         'depth',             // compartment depth (longer side)
  // WALLS_SURFACE_AREA:    'walls_surface_area',        // wall surface area
  // FLOOR_SURFACE_AREA:    'floor_surface_area',        // floor surface area - may differ from AREA if ceiling is sloped
  // PERIMETER:     'perimeter',         // compartment perimeter
  // AREA_PERCENTILE: 'area_percentile',
  // OUTDOOR_AREAS: 'outdoor_areas',
  // ENERGY?? ENERGY_GAINS?? SOLAR_GAINS??  'energy_gains'??,
  // AKUSTYKA??
}
